var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideMenuX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x92\x8E Icon=ExpandCollapse Sidemenu, Stroke=2.0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8C3.75 7.44772 4.19772 7 4.75 7L7.25 7C7.80229 7 8.25 7.44772 8.25 8C8.25 8.55229 7.80229 9 7.25 9L4.75 9C4.19772 9 3.75 8.55229 3.75 8Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 10C4.19772 10 3.75 10.4477 3.75 11C3.75 11.5523 4.19772 12 4.75 12H7.25C7.80229 12 8.25 11.5523 8.25 11C8.25 10.4477 7.80229 10 7.25 10L4.75 10Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V6C23 4.34314 21.6569 3 20 3H4C2.34315 3 1 4.34315 1 6V18ZM4 19C3.44772 19 3 18.5523 3 18L3 6C3 5.44772 3.44772 5 4 5L9 5L9 19H4ZM11 19L20 19C20.5523 19 21 18.5523 21 18V6C21 5.44771 20.5523 5 20 5L11 5L11 19Z",
    className: "Icon-fill-color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenuX2);
export default __webpack_public_path__ + "static/media/SideMenuX2.4e994e0f6c42b46426146d5907bdd545.svg";
export { ForwardRef as ReactComponent };